import { Component } from '@angular/core';
import { SessionService } from './services/session.service';
import { StorageService } from './services/storage.service';
import { ObservableService } from './services/observable.service';
import { ToastComponent, ToastUtility } from '@syncfusion/ej2-angular-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  loggedIn: boolean = false;
  error: string | null | undefined;
  success: string | null | undefined;
  public toastObj?: ToastComponent;
  /**
   *
   */
  constructor(
    public sessionService: SessionService,
    public storageService: StorageService,
    public observableService: ObservableService
  ) {
    sessionService.loginChanged(storageService.loggedIn);
  }

  async ngOnInit(): Promise<void> {
    this.sessionService.loggedIn.subscribe(
      session => this.loggedIn = session);
    this.observableService.error.subscribe(error => {
      this.error = error;
      if (this.error) {
        this.toastObj = ToastUtility.show(this.error, 'Error', 20000) as ToastComponent;
      }
    });
    this.observableService.success.subscribe(message => {
      this.success = message;
      if (this.success) {
        this.toastObj = ToastUtility.show(this.success, 'Success', 20000) as ToastComponent;
      }
    });
  }
}
